import SlidingPanel from "@components/sliders/SlidingPanel";
import React from "react";

interface SettledAccountReponseSliderProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  isSuccess?: boolean;
  errorMessage?: string;
  title?: string;
}

const SettledAccountReponseSlider: React.FC<
  SettledAccountReponseSliderProps
> = ({ isOpen, onClose, data, isSuccess = true, errorMessage = "", title = "Response: Settled Account" }) => {
  // Convert data to a formatted JSON string
  const formattedJson = JSON.stringify(data, null, 2);

  // Determine status message and styling based on success/error
  const statusMessageText = isSuccess ? "Success" : "Error";
  const statusBgColor = isSuccess ? "bg-bg-status-green" : "bg-bg-status-red";
  const statusTextColor = isSuccess
    ? "text-text-status-green"
    : "text-text-status-red";
  const statusBorderColor = isSuccess
    ? "border-bg-status-green"
    : "border-bg-status-red";

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={title}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className="p-4 flex flex-col gap-4">
        {/* Status indicator */}
        <div
          className={`p-3 rounded-md ${statusBgColor} border ${statusBorderColor}`}
        >
          <div className="flex items-center">
            <div className={`mr-2 ${statusTextColor} font-medium`}>
              {statusMessageText}
            </div>
            {isSuccess ? (
              <svg
                className="h-5 w-5 text-text-status-green"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                className="h-5 w-5 text-text-status-red"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
          {!isSuccess && errorMessage && (
            <p className={`mt-1 text-sm ${statusTextColor}`}>{errorMessage}</p>
          )}
        </div>

        {/* JSON Response */}
        <div className="border border-border-subtle rounded-md bg-bg-base">
          <div className="bg-gray-50 px-4 py-2 border-b border-border-subtle">
            <h3 className="text-sm font-medium">Response Data</h3>
          </div>
          <pre className="p-4 text-xs overflow-auto max-h-96 whitespace-pre-wrap break-all">
            {formattedJson || "No data available"}
          </pre>
        </div>
      </div>
    </SlidingPanel>
  );
};

export default SettledAccountReponseSlider;
